import { render, staticRenderFns } from "./alerts.component.vue?vue&type=template&id=56ba0fdf&"
import script from "./alerts.component.vue?vue&type=script&lang=ts&"
export * from "./alerts.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports